enum EndpointsExample {
  Example = '/example',
}

export default EndpointsExample;
